<template>
  <div>
    <v-container>
      <h5>{{ $t('Link with Facebook TAG') }}</h5>

      <div>{{ $t('Turn on/off') }} {{ $t('Link with Facebook TAG') }}</div>
      <label
        class="toggle-switch small"
        style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
      >
        <input type="checkbox" :checked="fbsyncTag" @change="toggleFacebookSyncTags()" />
        <span class="toggle-slider lever round"></span>
      </label>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  computed: {
    ...mapGetters({
      botlist: 'botlist',
      currentLang: 'currentLang',
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.fbsyncTag = this.selectedBot.synctagsfacebook_status
  },
  data() {
    return {
      fbsyncTag: false
    }
  },
  methods: {
    toggleFacebookSyncTags() {
      let vm = this
      vm.fbsyncTag = !vm.fbsyncTag
      var data = {
        params: {
          pageid: vm.selectedBot.pageid
        },
        body: { synctagsfacebook_status: vm.fbsyncTag }
      }

      vm.$store.dispatch('loading')
      api.toggleFacebookSyncTags(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        vm.$store.dispatch('updateBotDetail')

        vm.$store.dispatch('loading')
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/FacebookTags.vue